import api from '../config/api';

// Get Viator product recommendations for a destination
export const getViatorRecommendations = async (destination, limit = 10) => {
  const { data } = await api.get('/viator/recommendations', { 
    params: { destination, limit } 
  });
  return data?.activities || [];
};

// Search Viator products by query
export const searchViatorProducts = async (query, destination, limit = 10) => {
  const { data } = await api.get('/viator/search', { 
    params: { query, destination, limit } 
  });
  return data?.activities || [];
};

// Get city-specific activities (combines recommendations and search)
export const getViatorActivities = async (cityName, limit = 10) => {
  try {
    // Try recommendations first
    const recommendations = await getViatorRecommendations(cityName, Math.ceil(limit / 2));
    
    // Then search for specific activities
    const searchResults = await searchViatorProducts(cityName, cityName, Math.ceil(limit / 2));
    
    // Combine and deduplicate
    const allActivities = [...recommendations, ...searchResults];
    const uniqueActivities = allActivities.filter((activity, index, self) => 
      index === self.findIndex(a => a.id === activity.id)
    );
    
    return uniqueActivities.slice(0, limit);
  } catch (error) {
    console.error('Error fetching Viator activities:', error);
    return [];
  }
};

// Default export for service class
class ViatorService {
  async getRecommendations(destination, limit = 10) {
    const { data } = await api.get('/viator/recommendations', { 
      params: { destination, limit } 
    });
    return data;
  }

  async search(query, destination, limit = 10) {
    const { data } = await api.get('/viator/search', {
      params: { query, destination, limit }
    });
    return data;
  }
}

const viatorService = new ViatorService();
export default viatorService;
